var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0a67c8836fed3a23743eb7109aee6282.js').default;export default
        Object.assign({}, scope_0 )
    